<template>
  <form v-on:submit.prevent="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Add Zone</h4>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label for="zoneName">Name <span class="red-dot ml-3"></span></label>
        <input id="zoneName" name="zoneName" type="text" class="form-control" :class="{ 'is-invalid': errors.has('zoneName') }"
          autocomplete="off" placeholder="Name" v-model="zone.name" v-validate="'required'" data-vv-as="Name" />
        <div class="invalid-feedback">The Name field is required.</div>
      </div>
      <div class="form-group">
        <label for="zoneAbbreviation">Abbreviation <span class="red-dot ml-3"></span></label>
        <input id="zoneAbbreviation" name="zoneAbbreviation" type="text" class="form-control" :class="{ 'is-invalid': errors.has('zoneAbbreviation') }"
          autocomplete="off" placeholder="Abbreviation" v-model="zone.abbreviation" v-validate="'required'" data-vv-as="Abbreviation" />
        <div class="invalid-feedback">The Abbreviation field is required.</div>
      </div>
      <div class="form-group">
        <label for="zoneSortOrder">Sort Order <span class="red-dot ml-3"></span></label>
        <input id="zoneSortOrder" name="zoneSortOrder" type="text" class="form-control" :class="{ 'is-invalid': errors.has('zoneSortOrder') }"
          autocomplete="off" placeholder="Sort Order" v-model="zone.sortOrder" v-validate="'required'" data-vv-as="Sort Order" />
        <div class="invalid-feedback">The Sort Order field is required.</div>
      </div>
      <div class="form-group">
        <label for="zoneContactEmail">Contact Email</label>
        <v-select id="zoneContactEmail" name="zoneContactEmail" placeholder="Contact Email/s"
                  class="v-select-multi" :class="{ 'is-invalid': errors.has('zoneContactEmail') }"
                  multiple v-model="contactEmail" :options="[]" taggable
                  v-validate="'email'" data-vv-as="Contact Email">
                  <span slot="no-options"/>
        </v-select>
        <div class="invalid-feedback">An email is invalid</div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-success">Save</button>
      <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Toast from "@/utils/toast";

export default {
  name: 'contact-type',
  data: function () {
    return {
      isEdit: false,
      zone: {},
      contactEmail: []
    }
  },
  computed: {
    ...mapGetters(["getZone"])
  },
  mounted: function() {
    this.zone = { ...this.getZone };
    this.isEdit = !!this.zone.id;
    this.contactEmail = this.zone.contactEmail.length > 0 ? this.zone.contactEmail?.split(",") : []
    this.$validator.reset();
  },
  methods: {
    async onSubmit() {
      var isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }
      
      this.zone.contactEmail = this.contactEmail.join(',')
      this.saveZone({ data: this.zone, isEdit: this.isEdit })
        .then(() => {
          Toast.success(this, "Successfully saved!");
          this.$bvModal.hide("bv-modal-zone");
          this.closeModal();
        })
        .catch(() => {
          Toast.danger(this, "Oops! There was an error.");
          this.closeModal();
        });
    },
    closeModal() {
      this.$bvModal.hide("bv-modal-zone");
    },
    ...mapActions(["saveZone"])
  }
}
</script>
